import { awardPotsToWinners, calculatePlayerPositions } from './pokerLogic';
import { hasGenuineSidePots, potsForAward } from './potDisplay';
import { t } from '../i18n';

/**
 * Host can tap seats on the board (or rows in list view) instead of the
 * Declare Winner pop-up. Side pots keep today's picker — each pot can have
 * a different winner, and a seat tap cannot say that.
 */
export function isTapWinnerMode({ isHost, stage, totalPot, eligibleCount, players }) {
  return Boolean(
    isHost
    && stage === 'SHOWDOWN'
    && (totalPot || 0) > 0
    && (eligibleCount || 0) > 1
    && !hasGenuineSidePots(players)
  );
}

export function isEligibleWinnerSeat(player) {
  if (!player) return false;
  if (player.status === 'left') return false;
  if (player.hasFolded) return false;
  if (player.isActive === false) return false;
  return true;
}

/**
 * Main-button copy. 0 picks: muted "Award". One seat: "Award $8.00 to Sam".
 * Two or more: "Split $8.00". Uses the on-screen pot and currency.js.
 */
export function tapWinnerButtonLabel({ selectedIds, players, potCents, formatCurrency }) {
  const ids = selectedIds || [];
  if (ids.length === 0) return t('game.award');
  const pot = formatCurrency(potCents || 0);
  if (ids.length === 1) {
    const name = (players || []).find((p) => p.id === ids[0])?.name || t('common.player');
    return t('game.awardTo', { amount: pot, name });
  }
  return t('game.split', { amount: pot });
}

/**
 * Same award path GameBoard uses: return uncalled chips, then engine pots.
 * Empty winnerIds is a no-op (refresh mid-selection, or Award before a tap).
 */
export function awardFromTap(players, winnerIds, dealerId) {
  const ids = Array.isArray(winnerIds) ? winnerIds.filter(Boolean) : [];
  if (ids.length === 0) {
    return {
      updatedPlayers: (players || []).map((p) => ({ ...p })),
      playerWinnings: {},
      refunds: {},
      skipped: true,
    };
  }
  const { pots, players: settled } = potsForAward(players || []);
  const potsToAward = pots && pots.length > 0 ? pots : [];
  const playerPositions = calculatePlayerPositions(settled, dealerId);
  return awardPotsToWinners(potsToAward, ids, settled, playerPositions);
}
